import React from 'react';
import { Text, View, TouchableOpacity } from 'react-native';
import {
  GridTemplate,
  CardLinearTemplate,
  CardTemplate,
} from '@components/templates';
import CodeBox1 from '@images/card-icons/icon_box_1.svg';
import CodeBox2 from '@images/card-icons/icon_box_2.svg';
import CodeBox3 from '@images/card-icons/icon_box_3.svg';
import { styles } from './styles';

export const InCase = ({ title, detail, style, isMobile }) => {
  return (
    <View style={[styles.root, style]}>
      <Text style={styles.title}>В тариф входит:</Text>
      <View style={styles.rowBoxes}>
        <CardLinearTemplate
          colors={['#29D890', '#4FAA9F']}
          style={styles.containerBox}
          // onPress={() => navigation.navigate('TestListStackScreen')}
        >
          <View style={styles.iconContainer}>
            <CodeBox1 />
          </View>
          <Text style={[styles.titleInBox]}>Все области тестирования</Text>
        </CardLinearTemplate>
        <View style={styles.freeSpaceWidth} />
        <CardLinearTemplate
          colors={['#29D890', '#4FAA9F']}
          style={styles.containerBox} // onPress={() => navigation.navigate('TestListStackScreen')}
        >
          <View style={styles.iconContainer}>
            <CodeBox2 />
          </View>
          <Text style={[styles.titleInBox]}>Поиск по запросам</Text>
        </CardLinearTemplate>
      </View>
      <View style={styles.freeSpaceHeight} />

      <View style={styles.rowBoxes}>
        <CardLinearTemplate
          colors={['#29D890', '#4FAA9F']}
          style={styles.containerBox} // onPress={() => navigation.navigate('TestListStackScreen')}
        >
          <View style={styles.iconContainer}>
            <CodeBox1 />
          </View>
          <Text style={[styles.titleInBox]}>Тест по избранному</Text>
        </CardLinearTemplate>
        <View style={styles.freeSpaceWidth} />

        <CardLinearTemplate
          colors={['#29D890', '#4FAA9F']}
          style={styles.containerBox}
          styleContainer={styles.linearBox} // onPress={() => navigation.navigate('TestListStackScreen')}
        >
          <View style={styles.iconContainer}>
            <CodeBox2 />
          </View>
          <Text style={[styles.titleInBox]}>Режим тестирования и экзамена</Text>
        </CardLinearTemplate>
      </View>
    </View>
  );
};
